var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "code-input" },
    _vm._l(_vm.inputs, function (item, index) {
      return _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputs[index],
            expression: "inputs[index]",
          },
        ],
        key: index,
        ref: "inputs",
        refInFor: true,
        staticClass: "code-box",
        attrs: { type: "text", maxlength: "1", inputmode: "numeric" },
        domProps: { value: _vm.inputs[index] },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputs, index, $event.target.value)
            },
            function ($event) {
              return _vm.onInput(index)
            },
          ],
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k(
                $event.keyCode,
                "backspace",
                undefined,
                $event.key,
                undefined
              )
            ) {
              return null
            }
            return _vm.onBackspace(index)
          },
        },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }